import script from "./FloatingClassroomAi.vue?vue&type=script&setup=true&lang=ts"
export * from "./FloatingClassroomAi.vue?vue&type=script&setup=true&lang=ts"

import "./FloatingClassroomAi.vue?vue&type=style&index=0&id=c5ff4fc6&lang=less&scoped=true"
import "./FloatingClassroomAi.vue?vue&type=style&index=1&id=c5ff4fc6&lang=less"

import exportComponent from "/home/jenkins_home/workspace/c1-02_dwart2.0-apkpc-site/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c5ff4fc6"]])

export default __exports__